<template>
  <div>
    <b-form-file
      :disabled="Boolean(uploadInProgress)"
      :multiple="Boolean(multiple)"
      :accept="String(acceptedTypes)"
      v-model="selectedFiles"
      :state="validationState"
      placeholder="Choose a file or drop it here..."
      :file-name-formatter="formatNames"
      drop-placeholder="Drop file here..."
      @input="onSelectFile"
    />

    <b-list-group class="my-3 no-round">
      <transition name="fade" mode="out-in">
      <b-list-group-item
        v-for="item in items"
        :key="item.id"
        class="d-flex justify-content-between align-items-center no-round p-1"
      >
        <div>
          <transition name="fade" mode="in-out">
            <img
              :src="item.img"
              height="100"
              v-if="!imageCrop || item.cropped"
            />
          </transition>
        </div>

          <div v-if="imageCrop && !item.cropped">
            <cropper
              :ref="'cropper' + item.id"
              classname="cropper"
              :src="item.img"
              :stencil-props="{
                aspectRatio: imageCropRatio,
              }"
            >
            </cropper>

            <span
              v-if="item.progress === 0 && !item.cropped"
              style="cursor:pointer"
              title="Delete"
              @click="croppedImg(item.id)"
              class="btn btn-xs btn-success mt-1"
              >CROP
              <i class="iconsminds-yes" />
            </span>
          </div>

        <div>
          <b-badge
            :variant="item.progress == 100 ? 'success' : 'primary'"
            v-if="imageCrop ? (item.cropped ? true : false) : true"
            pill
            >{{ item.progress }}%
          </b-badge>
          <span
            v-if="item.progress === 100"
            style="cursor:pointer"
            title="Delete"
            @click="deleteImg(item.id)"
            class="text-danger"
          >
            <i class="iconsminds-close" />
          </span>
        </div>
      </b-list-group-item>
       </transition>
    </b-list-group>

  </div>
</template>

<script>
import fileRepo from '@/api/repos/fileRepo'
import { Cropper } from 'vue-advanced-cropper'

export default {
  components: {
    Cropper
  },
  props: {
    multiple: {
      default: false,
      type: Boolean
    },

    acceptedTypes: {
      default: '*',
      type: String
    },
    validationState: {
      default: null,
      type: Boolean
    },
    imageCrop: {
      default: false,
      type: Boolean
    },
    imageCropRatio: {
      default: 16 / 9,
      type: Number
    }
  },
  computed: {
    uploadedImages () {
      if (this.fileIds.length > 0) {
        return this.fileIds.toString()
      }
      return null
    },
    uploadStatus () {
      return false
    }
  },
  data () {
    return {
      imageUploadUrl: 'api/images',
      selectedFiles: null,
      items: [],
      uploadInProgress: false,
      fileIds: []
    }
  },
  methods: {
    formatNames (files) {
      if (files.length === 1) {
        return files[0].name
      } else {
        return `multiple files selected`
      }
    },
    onSelectFile () {
      if (this.selectedFiles !== null) {
        this.$emit('files-uploaded-started')
        let fileList = this.selectedFiles
        // this.selectedFiles = null
        this.items = []
        this.fileIds = []

        if (this.multiple) {
          fileList.forEach((file, i) => {
            const reader = new FileReader()
            reader.onload = e => {
              this.items.push({ id: i, img: e.target.result, progress: 0 })
              if (!this.imageCrop) this.uploadImage(file, i)
            }
            reader.readAsDataURL(file)
          })
        } else {
          const reader = new FileReader()
          reader.onload = e => {
            this.items.push({ id: 0, img: e.target.result, progress: 0 })
            if (!this.imageCrop) this.uploadImage(fileList, 0)
          }
          reader.readAsDataURL(fileList)
        }
      }
    },

    onProgress (percent, id) {
      this.items = this.items.map(x => {
        if (x.id === id) {
          return { ...x, progress: percent }
        }
        return x
      })
    },

    async uploadImage (file, id) {
      try {
        let { data } = await fileRepo.upload(
          this.imageUploadUrl,
          file,
          this.onProgress,
          id
        )
        if (this.multiple) {
          this.fileIds.push(data.id)
        } else {
          this.fileIds[0] = data.id
        }
        // set new returned id and mark as 100%
        this.items = this.items.map(x => {
          if (x.id === id) {
            return { ...x, id: data.id, progress: 100 }
          }
          return x
        })

        // check all uploaded and notify
        if (this.items.length === this.fileIds.length) {
          this.$emit('files-uploaded', this.uploadedImages)
        }
      } catch (error) {
        console.log(error.response)
      }
    },

    deleteImg (id) {
      this.fileIds = this.fileIds.filter(x => x !== id)
      this.items = this.items.filter(x => x.id !== id)
      this.$emit('files-uploaded', this.uploadedImages)
    },

    croppedImg (id) {
      const { canvas } = this.$refs['cropper' + id][0].getResult()
      this.items = this.items.map(x => {
        if (x.id === id) {
          return { ...x, img: canvas.toDataURL(), cropped: true }
        }
        return x
      })

      canvas.toBlob(blob => {
        this.uploadImage(blob, id)
      }, 'image/png')
    }
  }
}
</script>

<style scoped>
.cropper {
  height: 160px;
}
</style>
